import validate from "/var/jenkins_home/workspace/pdf_web_biz/node_modules/nuxt/dist/pages/runtime/validate.js";
import default_45global from "/var/jenkins_home/workspace/pdf_web_biz/middleware/default.global.ts";
import manifest_45route_45rule from "/var/jenkins_home/workspace/pdf_web_biz/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  default_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {}